/* eslint-disable @typescript-eslint/no-magic-numbers,spellcheck/spell-checker */
import { addMinutes } from 'date-fns';

import {
    AppPhase,
    DealerAssistTableErrorCode,
    GameType,
    NotificationCode,
    NotificationSeverity,
    TableMode
} from '../models/communication/app-enums.model';
import { AppEventType } from '../models/communication/app-events.model';
import { AppState } from '../models/communication/app-state.model';
import { YEventPayload } from '../models/y-protocol.model';

export const config = {
    appVersion: '1.0.0-demo',
    tableId: 'tronius-table-1',
    bettingWindowInSeconds: 3,
    // eslint-disable-next-line spellcheck/spell-checker
    videoStreamId: '2e23782e-8151-4b7f-8ccd-2d9771aa9924',
    gameType: GameType.Baccarat,
    tableMode: TableMode.Online
};

export const getDemoInitialState = (gameConfig: Partial<AppState['configuration']> = {}): AppState => ({
    games: [GameType.Baccarat, GameType.DragonTiger, GameType.OpenBaccarat, GameType.OpenDragonTiger, GameType.ThreeHeadedDragon],

    configuration: {
        ...config,
        ...gameConfig
    },

    roundState: {
        phase: AppPhase.WaitingForCroupier
    },

    flagsState: {
        chatEnabled: true
    },

    chatMessages: [
        {
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            from: 'Billy Bob',
            timestamp: addMinutes(Date.now(), -3).getTime()
        },
        {
            content: 'Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam quis.',
            from: 'Supervisor',
            timestamp: addMinutes(Date.now(), -4).getTime(),
            isSupervisor: true
        },
        {
            content: 'Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.',
            from: 'John Doe',
            timestamp: addMinutes(Date.now(), -5).getTime()
        },
        {
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            from: 'Billy Bob',
            timestamp: addMinutes(Date.now(), -6).getTime()
        },
        {
            content: 'Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam quis risus eget urna mollis ornare vel eu leo.',
            from: 'Supervisor',
            timestamp: addMinutes(Date.now(), -7).getTime(),
            isSupervisor: true
        },
        {
            content: 'Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.',
            from: 'John Doe',
            timestamp: addMinutes(Date.now(), -8).getTime()
        },
        {
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            from: 'Billy Bob',
            timestamp: addMinutes(Date.now(), -9).getTime()
        },
        {
            content: 'Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam quis risus eget urna mollis ornare vel eu leo.',
            from: 'Supervisor',
            timestamp: addMinutes(Date.now(), -10).getTime(),
            isSupervisor: true
        },
        {
            content: 'Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.',
            from: 'John Doe',
            timestamp: addMinutes(Date.now(), -11).getTime()
        }
    ]
});

export const demoEvents: Array<Omit<YEventPayload<AppEventType>, 'triggered'>> = [
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.WaitingForCroupier
        }
    },
    {
        name: AppEventType.LoginChange,
        data: {
            new: {
                id: 'croupier-id-123',
                name: 'Cardie Dee'
            }
        }
    },
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.WaitingForPlayers
        }
    },
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.RoundVoid
        }
    },
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.RoundError,
            errorCode: DealerAssistTableErrorCode.BackendDisconnected
        }
    },
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.ShoeChange
        }
    },
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.CardBurn
        }
    },
    {
        name: AppEventType.CardBurn,
        data: {
            card: 208,
            burnedCount: 0,
            totalToBurnCount: 7
        }
    },
    {
        name: AppEventType.ChatMessage,
        data: {
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id dolor id nibh ultricies vehicula',
            from: 'Dick Tracy',
            timestamp: Date.now()
        }
    },
    {
        name: AppEventType.CardBurn,
        data: {
            card: 208,
            burnedCount: 1,
            totalToBurnCount: 7
        }
    },
    {
        name: AppEventType.CardBurn,
        data: {
            card: 208,
            burnedCount: 2,
            totalToBurnCount: 7
        }
    },
    {
        name: AppEventType.CardBurn,
        data: {
            card: 208,
            burnedCount: 3,
            totalToBurnCount: 7
        }
    },
    {
        name: AppEventType.Notification,
        data: {
            code: NotificationCode.ScannerDisconnected,
            severity: NotificationSeverity.Warning
        }
    },
    // The notification must dissapear after the next event.
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.NewRoundPreparation,
            roundId: 3 + Math.round(Math.random() * 100)
        }
    },
    {
        name: AppEventType.Notification,
        data: {
            code: NotificationCode.ScannerConnected,
            severity: NotificationSeverity.Info
        }
    },
    {
        name: AppEventType.PlayerCountChange,
        data: {
            count: 10 + Math.round(Math.random() * 100)
        }
    },
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.BetsOpen
        }
    },
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.BetsClosed
        }
    }
];
